export default __webpack_public_path__ + "static/media/note-icon.02fea621.svg";